import React, {useEffect, useState} from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import styles from '../UI/UI.module.css';
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import RedeemRecordItem from "@/app/(redeem)/redeemRecord/RedeemRecordItem";
import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import {RedeemRecordInfo} from "@/Core/Redeem/redeemEntity";
import Load from "@/app/_components/Load/Load";
import {RedeemChannelType} from "@/Core/Redeem/RedeemChannelType";
import {useAppSelector} from "@/app/storeHooks";
import {selectMainState} from "@/app/MainSlice";

interface RedeemSubmittedDialogProps extends SDialogProps {
    redeemOrderData: RedeemOrderData,
}

export const RedeemSubmittedDialogFC: React.FC<RedeemSubmittedDialogProps> = (props) => {
    const {fcKey, onClose, redeemOrderData} = props;
    const [redeemRecordInfo, setRedeemRecordInfo] = useState<RedeemRecordInfo>();

    const {cashAppValidDays} = useAppSelector(selectMainState);
    const {closeDialog} = useDialogMethods(fcKey, {
        open: () => {
        },
        close: () => {
            onClose?.();
        }
    });

    const onCloseDialog = () => {
        closeDialog();
        onClose?.();
    }

    const onBtnClick = () => {
        onCloseDialog();
    }

    useEffect(() => {
        const info = RedeemManager.CreateRecordInfo(redeemOrderData);
        setRedeemRecordInfo(info);


    }, []);

    return (
        <SDialogFC
            fcKey={fcKey}
            onClose={onClose}
            mode="Center"
            title={(
                <section>
                    <div style={{
                        width: '2.4rem',
                        height: '2.4rem',
                        position: 'absolute',
                        top: '-2rem',
                        left: '50%',
                        marginLeft: '-1.2rem',
                        zIndex: 1,
                    }}>
                        <img src='/img/redeem/icon_ok.webp'/>
                    </div>
                    <div style={{zIndex: '2', position: 'relative', padding: '0.5rem 0'}}>REDEMPTION SUBMITTED</div>
                </section>
            )}
        >
            <div className={styles.success}>
                <section>
                    <section className={`${styles.s_head} center-space-between`}>
                        <section className={`${styles.s_col}`}>Redemption</section>
                        <section className={`${styles.s_col}`}>Account</section>
                        <section className={`${styles.s_col}`}>Status</section>
                    </section>
                    {
                        redeemRecordInfo ? <RedeemRecordItem redeemRecordInfo={redeemRecordInfo}/> : <Load/>
                    }
                </section>

                <div style={{
                    fontSize: '0.28rem',
                    lineHeight: '0.28rem',
                    color: '#9399FC',
                }}>
                    <span>It may take 1 or 2 weeks to identify whether you are a robot, Cancellation is acceptable before
                    successful payment and the redemption amount will be returned. But cannot be canceled while your
                    withdrawal is processing. You cannot submit a new withdrawal request until your last withdrawal is
                    solved.</span>
                </div>

                {
                    redeemOrderData.channelType == RedeemChannelType.CashApp && (
                        <div style={{
                            fontSize: '0.35rem',
                            lineHeight: '0.35rem',
                            fontWeight:'500',
                            paddingTop: '0.2rem',
                            color: '#fe2733',
                        }}>
                            <span>*The successful order maybe cancelled by CashApp, please login CashApp within {cashAppValidDays} days to check. If you have any questions about the order,Please contact customer service.</span>
                        </div>
                    )
                }


            </div>
        </SDialogFC>
    );
};
